(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mziho-filter-gallery"] && !Shopify.designMode) return;
  try {
    
  class MzihoFilterGallery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.initialize();
    }

    async initialize() {
      this.groups = [
        'product',
        'type',
        'industry',
        'size',
        'edge',
        'plating'
      ];

      this.pageSize = Number(this.dataset.pageSize) || 36;
      this.visibleLimit = this.pageSize;
      this.showCaptions =
        this.dataset.showCaptions === 'true';
      this.urlPrefix = this.dataset.urlPrefix || 'gallery';

      this.grid = this.querySelector('[data-grid]');
      this.loading = this.querySelector('[data-loading]');
      this.empty = this.querySelector('[data-empty]');
      this.loadMoreWrap = this.querySelector(
        '[data-load-more-wrap]'
      );
      this.loadMoreButton = this.querySelector(
        '[data-load-more]'
      );
      this.showingCounts = this.querySelectorAll(
        '[data-showing-count]'
      );
      this.resultCounts = this.querySelectorAll(
        '[data-result-count]'
      );
      this.clearButtons = this.querySelectorAll('[data-clear]');
      this.activeCount = this.querySelector(
        '[data-active-count]'
      );
      this.dialog = this.querySelector('[data-dialog]');
      this.dialogImage = this.querySelector(
        '[data-dialog-image]'
      );
      this.dialogCaption = this.querySelector(
        '[data-dialog-caption]'
      );

      this.items = await this.readItems();

      this.active = new Map(
        this.groups.map((group) => [group, new Set()])
      );

      this.bindEvents();
      this.restoreFromUrl();
      this.syncActiveFromInputs();
      this.prepareOptions();
      this.render();
    }

    async readItems() {
      try {
        const source = this.querySelector(
          '[data-mziho-gallery-gzip]'
        )?.textContent.trim();

        if (!source) return [];

        const bytes = Uint8Array.from(
          atob(source),
          (character) => character.charCodeAt(0)
        );

        const stream = new Blob([bytes])
          .stream()
          .pipeThrough(new DecompressionStream('gzip'));

        const parsed = JSON.parse(
          await new Response(stream).text()
        );

        return parsed.map((row) => ({
          url: row[0],
          title: row[1],
          alt: row[2],
          product: row[3],
          type: this.splitValues(row[4]),
          industry: this.splitValues(row[5]),
          size: this.splitValues(row[6]),
          edge: this.splitValues(row[7]),
          plating: this.splitValues(row[8]),
          width: Number(row[9]) || 1080,
          height: Number(row[10]) || 1080
        }));
      } catch (error) {
        console.error(
          'MZIHO gallery data could not be parsed.',
          error
        );

        return [];
      }
    }

    splitValues(value) {
      return value
        ? String(value).split('|').filter(Boolean)
        : [];
    }

    bindEvents() {
      this.addEventListener('change', (event) => {
        if (!event.target.matches('[data-filter-input]')) {
          return;
        }

        this.visibleLimit = this.pageSize;
        this.syncActiveFromInputs();
        this.updateUrl();
        this.render();
      });

      for (const button of this.clearButtons) {
        button.addEventListener(
          'click',
          () => this.clearFilters()
        );
      }

      this.loadMoreButton?.addEventListener('click', () => {
        this.visibleLimit += this.pageSize;
        this.render();
      });

      this.querySelector('[data-mobile-open]')
        ?.addEventListener(
          'click',
          () => this.setMobileOpen(true)
        );

      for (
        const button of this.querySelectorAll(
          '[data-mobile-close]'
        )
      ) {
        button.addEventListener(
          'click',
          () => this.setMobileOpen(false)
        );
      }

      this.querySelector('[data-dialog-close]')
        ?.addEventListener(
          'click',
          () => this.dialog?.close()
        );

      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) {
          this.dialog.close();
        }
      });
    }

    setMobileOpen(open) {
      this.dataset.mobileOpen = open ? 'true' : 'false';

      document.documentElement.style.overflow =
        open ? 'hidden' : '';

      const firstInput = this.querySelector(
        '[data-filter-input]:not(:disabled)'
      );

      if (open) {
        window.setTimeout(
          () => firstInput?.focus(),
          230
        );
      }
    }

    syncActiveFromInputs() {
      for (const group of this.groups) {
        this.active.set(group, new Set());
      }

      for (
        const input of this.querySelectorAll(
          '[data-filter-input]:checked'
        )
      ) {
        this.active
          .get(input.dataset.group)
          ?.add(input.value);
      }
    }

    restoreFromUrl() {
      const params = new URLSearchParams(
        window.location.search
      );

      for (const group of this.groups) {
        const raw = params.get(
          `${this.urlPrefix}_${group}`
        );

        if (!raw) continue;

        const values = new Set(
          raw.split(',').filter(Boolean)
        );

        for (
          const input of this.querySelectorAll(
            `[data-filter-input][data-group="${group}"]`
          )
        ) {
          input.checked = values.has(input.value);
        }
      }
    }

    updateUrl() {
      const url = new URL(window.location.href);

      for (const group of this.groups) {
        const values = [
          ...(this.active.get(group) || [])
        ];

        const key = `${this.urlPrefix}_${group}`;

        if (values.length) {
          url.searchParams.set(
            key,
            values.join(',')
          );
        } else {
          url.searchParams.delete(key);
        }
      }

      window.history.replaceState(
        {},
        '',
        `${url.pathname}${url.search}${url.hash}`
      );
    }

    clearFilters() {
      for (
        const input of this.querySelectorAll(
          '[data-filter-input]'
        )
      ) {
        input.checked = false;
      }

      this.visibleLimit = this.pageSize;
      this.syncActiveFromInputs();
      this.updateUrl();
      this.render();
    }

    itemValues(item, group) {
      const value = item[group];

      return Array.isArray(value)
        ? value
        : value
          ? [value]
          : [];
    }

    matches(item, ignoredGroup = '') {
      for (const group of this.groups) {
        if (group === ignoredGroup) continue;

        const selected = this.active.get(group);

        if (!selected?.size) continue;

        const values = this.itemValues(item, group);

        if (
          !values.some(
            (value) => selected.has(value)
          )
        ) {
          return false;
        }
      }

      return true;
    }

    prepareOptions() {
      for (
        const input of this.querySelectorAll(
          '[data-filter-input]'
        )
      ) {
        const group = input.dataset.group;

        const count = this.items.filter(
          (item) =>
            this.itemValues(item, group)
              .includes(input.value)
        ).length;

        input.closest('[data-option-row]').hidden =
          count === 0;
      }

      for (
        const groupElement of this.querySelectorAll(
          '[data-filter-group]'
        )
      ) {
        groupElement.hidden =
          !groupElement.querySelector(
            '[data-option-row]:not([hidden])'
          );
      }
    }

    updateOptionCounts() {
      for (
        const input of this.querySelectorAll(
          '[data-filter-input]'
        )
      ) {
        const group = input.dataset.group;

        const count = this.items.filter((item) => {
          return (
            this.matches(item, group)
            && this.itemValues(item, group)
              .includes(input.value)
          );
        }).length;

        const row = input.closest('[data-option-row]');

        row.querySelector(
          '[data-option-count]'
        ).textContent = String(count);

        input.disabled =
          count === 0 && !input.checked;
      }
    }

    updateActiveCounts() {
      let total = 0;

      for (const group of this.groups) {
        const count =
          this.active.get(group)?.size || 0;

        total += count;

        const badge = this.querySelector(
          `[data-group-count="${group}"]`
        );

        if (badge) {
          badge.textContent = String(count);
          badge.hidden = count === 0;
        }
      }

      if (this.activeCount) {
        this.activeCount.textContent =
          String(total);

        this.activeCount.hidden =
          total === 0;
      }

      for (const button of this.clearButtons) {
        button.disabled = total === 0;
      }
    }

    render() {
      const matches = this.items.filter(
        (item) => this.matches(item)
      );

      const visible = matches.slice(
        0,
        this.visibleLimit
      );

      this.grid.replaceChildren(
        ...visible.map(
          (item) => this.createCard(item)
        )
      );

      this.loading.hidden = true;
      this.empty.hidden = matches.length !== 0;
      this.loadMoreWrap.hidden =
        matches.length <= visible.length;

      this.updateOptionCounts();
      this.updateActiveCounts();
      this.updateResultText(
        matches.length,
        visible.length
      );
    }

    updateResultText(total, shown) {
      const resultText =
        this.dataset.resultTemplate.replace(
          '__count__',
          String(total)
        );

      const showingText =
        this.dataset.showingTemplate
          .replace('__shown__', String(shown))
          .replace('__total__', String(total));

      for (const element of this.resultCounts) {
        element.textContent = resultText;
      }

      for (const element of this.showingCounts) {
        element.textContent = showingText;
      }
    }

    createCard(item) {
      const article =
        document.createElement('article');

      article.className =
        'mziho-gallery__card';

      const button =
        document.createElement('button');

      button.className =
        'mziho-gallery__image-button';

      button.type = 'button';

      button.setAttribute(
        'aria-label',
        `${this.dataset.zoomLabel}: ${item.title}`
      );

      button.addEventListener(
        'click',
        () => this.openDialog(item)
      );

      const image =
        document.createElement('img');

      image.className =
        'mziho-gallery__image';

      image.src =
        this.thumbnailUrl(item.url);

      image.alt = item.alt;
      image.width = item.width;
      image.height = item.height;
      image.loading = 'lazy';
      image.decoding = 'async';

      button.append(image);
      article.append(button);

      if (this.showCaptions) {
        const caption =
          document.createElement('p');

        caption.className =
          'mziho-gallery__caption';

        caption.textContent = item.title;
        article.append(caption);
      }

      return article;
    }

    thumbnailUrl(source) {
      try {
        const url = new URL(source);
        url.searchParams.set('width', '720');
        return url.toString();
      } catch {
        return source;
      }
    }

    openDialog(item) {
      this.dialogImage.src = item.url;
      this.dialogImage.alt = item.alt;
      this.dialogImage.width = item.width;
      this.dialogImage.height = item.height;

      this.dialogCaption.textContent =
        item.title;

      if (
        typeof this.dialog.showModal
        === 'function'
      ) {
        this.dialog.showModal();
      }
    }
  }

  if (
    !customElements.get('mziho-filter-gallery')
  ) {
    customElements.define(
      'mziho-filter-gallery',
      MzihoFilterGallery
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__productTabsSectionBound) return;
    window.__productTabsSectionBound = true;

    function renderVideo(scope) {
      const root = scope || document;
      root.querySelectorAll('.video-open-popup:not([data-video-bound])').forEach((videoOpenPopup) => {
        videoOpenPopup.dataset.videoBound = 'true';
        videoOpenPopup.addEventListener('click', function (e) {
          e.preventDefault();
          const videoId = videoOpenPopup.dataset.videoId;
          const videoWrapper = document.querySelector('.video-modal__content-block');
          if (!videoWrapper || !videoId) return;
          videoWrapper.innerHTML = `<iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
        });
      });
    }

    function ensureVideoModal() {
      if (document.getElementById('PopupModal-product-tabs-video')) return;
      document.body.insertAdjacentHTML(
        'beforeend',
        `<side-drawer class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden" id="PopupModal-product-tabs-video" data-moved="true">
          <div class="drawer__overlay fixed inset-0 cursor-pointer"></div>
          <div class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup">
            <div class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar">
              <div class="video-modal__content-block">Video</div>
              <button onclick="this.closest('side-drawer').close()" class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute" type="button" aria-label="Close dialog" style="--top: 0.3rem; --right: 0.3rem">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg>
              </button>
            </div>
          </div>
        </side-drawer>`
      );
    }

    function openAccordionTab(tabContent) {
      const section = tabContent.closest('.section-product-tabs');
      if (!section) return;
      section.querySelectorAll('.style-accordion .toggle-title.is-open').forEach((el) => el.classList.remove('is-open'));
      tabContent.querySelector('.toggle-title')?.classList.add('is-open');
    }

    function closeAccordionTab(tabContent) {
      tabContent.querySelector('.toggle-title')?.classList.remove('is-open');
    }

    document.addEventListener('click', function (e) {
      const section = e.target.closest('.section-product-tabs');
      if (!section) return;

      const tabTitle = e.target.closest('.tab-title');
      if (tabTitle && section.contains(tabTitle)) {
        e.preventDefault();
        const tabList = section.querySelector('.tabs-list');
        if (!tabList) return;
        const tabTitles = [...tabList.querySelectorAll('.tab-title')];
        const tabContents = [...section.querySelectorAll('.product-tabs-tab .tabs-content > .tab-content')];
        const index = tabTitles.indexOf(tabTitle);
        if (index === -1 || tabTitle.classList.contains('is-active')) return;
        tabTitles.forEach((t) => t.classList.remove('is-active'));
        tabContents.forEach((c) => c.classList.remove('is-active'));
        tabTitle.classList.add('is-active');
        setTimeout(() => {
          const content = tabContents[index];
          if (!content) return;
          content.classList.add('is-animating', 'is-active');
          content.addEventListener(
            'transitionend',
            function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            },
            { once: true }
          );
        }, 10);
        return;
      }

      const toggleLink = e.target.closest('.toggle-link');
      if (!toggleLink || !section.contains(toggleLink)) return;
      e.preventDefault();

      const toggleTitle = toggleLink.closest('.toggle-title');
      if (!toggleTitle) return;

      const tabTitleText = document.querySelector('.tab-title-text');
      if (tabTitleText) tabTitleText.textContent = toggleLink.textContent;

      const viewContentType = toggleTitle.dataset.viewContent;
      const content = toggleTitle.nextElementSibling;
      if (!content) return;

      if (Shopify?.designMode && section.querySelector('.style-accordion')) return;

      switch (viewContentType) {
        case 'sidebar': {
          const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
          if (drawerContent) {
            drawerContent.innerHTML = '';
            drawerContent.appendChild(content.cloneNode(true));
            renderVideo(drawerContent);
          }
          break;
        }
        case 'popup': {
          const popupContent = document.querySelector('.popup-content-wrapper');
          if (popupContent) {
            popupContent.innerHTML = '';
            popupContent.appendChild(content.cloneNode(true));
            renderVideo(popupContent);
          }
          break;
        }
        default:
          toggleTitle.classList.toggle('is-open');
      }
    });

    if (Shopify?.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        openAccordionTab(tabContent);
      });

      document.addEventListener('shopify:block:deselect', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        closeAccordionTab(tabContent);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      ensureVideoModal();
      renderVideo();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
